(function () {
  function init(root) {
    if (!root || root.dataset.dkfInit === '1') return;
    root.dataset.dkfInit = '1';

    var accordion = root.querySelector('[data-dkf-accordion]');
    if (!accordion) return;

    var singleOpen = root.getAttribute('data-dkf-single') !== 'false';
    var items = accordion.querySelectorAll('[data-dkf-item]');

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        item.classList.toggle('is-open', item.open);
        if (!singleOpen || !item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dkf-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-dkf-section]').forEach(function (el) {
      delete el.dataset.dkfInit;
    });
    boot(e.target);
  });
})();
